export const ASK_RECOVER_PASSWORD = 'ASK_RECOVER_PASSWORD';
export const RESET_RECOVER_PASSWORD = 'RESET_RECOVER_PASSWORD';
